module.exports = __webpack_public_path__ + "static/media/3.8402bc0e.jpg";